module.exports = __webpack_public_path__ + "static/media/tutoring-service-bg.217a63b1.png";